const uclContent = {
  preview: `The UEFA Champions League 2024/25 has adopted its expanded format, bringing more clubs 
  and more drama to Europe's premier club competition. The league phase has produced stunning upsets 
  and dominant performances, setting up a knockout stage filled with mouth-watering ties. Real Madrid 
  seek a record-extending title while English clubs aim to reassert Premier League dominance in Europe.`,

  keyStories: [
    {
      title: "New Format, New Excitement",
      desc: "The expanded 36-team league phase has created more high-stakes matches early in the competition, eliminating the predictable group stage results."
    },
    {
      title: "English Clubs' European Form",
      desc: "Premier League representatives have shown strong European form, with multiple clubs targeting deep runs."
    },
    {
      title: "Real Madrid's Trophy Hunger",
      desc: "Los Blancos remain the benchmark in European football, with their squad built specifically to win in knockout football."
    },
  ],

  titleContenders: [
    "Real Madrid", "Manchester City", "Bayern Munich", "Arsenal", "PSG", "Inter Milan"
  ],

  fullPreview: `
    <h3>UEFA Champions League 2024/25 — Full Analysis</h3>
    <p>Europe's elite club competition has never been more competitive. The expanded format ensures 
    that even the strongest clubs cannot afford complacency in the early stages, raising the quality 
    and stakes of every match from September through to the final in May.</p>
    
    <h3>Favorites Analysis</h3>
    <p>Real Madrid's unparalleled experience in this competition makes them perennial favorites. 
    Their ability to raise performance levels on European nights at the Bernabeu is a unique 
    psychological advantage that statistics alone cannot capture.</p>
    
    <h3>PitchFacts Prediction</h3>
    <p>Real Madrid and Manchester City are projected as the two most likely finalists based on 
    squad depth, current form, and historical Champions League performance metrics.</p>
  `,
};

export default uclContent;